import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';

export default function Totals({ t, isLoading, totalSegments }) {
  const totalsToDisplay = (totalSegments || []).filter((e) =>
    [
      'tax',
      'subtotal',
      'discount',
      'rabah_redeemed_mobile_number',
      'amstorecredit',
    ].includes(e?.code)
  );

  const grandTotalSegment = totalSegments?.find(
    (e) => e?.code === 'grand_total'
  );
  if (grandTotalSegment) {
    totalsToDisplay.push(grandTotalSegment);
  }

  const SkeletonRow = () => (
    <div className='my-1 flex animate-pulse justify-between'>
      <div className='h-4 w-24 rounded bg-gray-200'></div>
      <div className='h-4 w-14 rounded bg-gray-200'></div>
    </div>
  );

  return (
    <div className='border-t border-[#e2e8f0] bg-inherit px-3.5 py-3'>
      {isLoading || !totalSegments?.length
        ? Array(4)
            .fill(0)
            .map((_, i) => <SkeletonRow key={i} />)
        : totalsToDisplay?.map((total) => {
            const isTotal = total?.code === 'grand_total';
            const isSubtotal = total?.code === 'subtotal';
            const isDiscount = total?.code === 'discount';
            return (
              <div
                className={`my-1 flex justify-between ${
                  isTotal ? 'text-lg font-extrabold' : 'font-medium'
                } `}
                key={total?.code}
              >
                <span>
                  {total?.code !== 'rabah_redeemed_mobile_number' &&
                  total?.code !== 'amstorecredit'
                    ? t(total?.code === 'discount' ? 'Discount' : total?.title)
                    : total?.title}
                </span>
                <span
                  className={`flex items-center gap-1 ${
                    isSubtotal && 'font-bold'
                  } ${(isDiscount || total?.value <= 0) && 'text-green-500'} `}
                >
                  {handlePriceByComma(total?.value)}
                  <CurrencyIcon className='size-3' />
                </span>
              </div>
            );
          })}
    </div>
  );
}
